export default __webpack_public_path__ + "static/media/menu_black_24dp.c4cfbab0.svg";